import { AdditionalInterestType } from "@covertree/new-business-graphql";

const additionalInterestLabels: Record<AdditionalInterestType, string> = {
  [AdditionalInterestType.Lienholder]: "Lienholder",
  [AdditionalInterestType.HomeownersAssociation]: "Homeowner's Association",
  [AdditionalInterestType.GovernmentMunicipality]: "Government/Municipality",
  [AdditionalInterestType.PropertyManagerParkOwner]:
    "Property Manager/Park Owner",
  [AdditionalInterestType.NotListed]: "Not Listed",
};

/**
 * Maps additional interest type to a label
 * @param additionalInterestType - Type of additional interest
 * @returns Additiional interest label
 */
const mapAdditionalInterestTypeToLabel = (
  additionalInterestType: AdditionalInterestType
): string => additionalInterestLabels[additionalInterestType];

export { mapAdditionalInterestTypeToLabel };
